import { Requests } from '../../../Common/Constants/Requests.Constants';
import { AppSessionContext } from '../SessionContext/AppSessionContext';
import TelemetryService from '../Telemetry/TelemetryService';

export class BaseSupportService {
  protected static instance: BaseSupportService;
  protected telemetryService: TelemetryService;
  protected appSessionContext: AppSessionContext;
  protected locale: string;

  protected constructor() {
    this.appSessionContext = AppSessionContext.getInstance();
    this.locale = this.appSessionContext.Locale;
    this.telemetryService = TelemetryService.getInstance();
  }

  public static getInstance = () => {
    if (!BaseSupportService.instance) {
      BaseSupportService.instance = new BaseSupportService();
    }
    return BaseSupportService.instance;
  };

  protected retry = (
    supportServiceFn: any,
    supportServiceUrl: string,
    supportServiceRequest: any | null = null,
    retriesLeft = 3,
    interval = 1000
  ) => {
    return new Promise((resolve, reject) => {
      supportServiceFn(supportServiceUrl, supportServiceRequest).then(
        (response: any) => {
          if (!response) {
            this.telemetryService.traceError(Requests.HttpResponse, {
              url: supportServiceUrl,
              request: supportServiceRequest,
              message: 'Api call succeeded but no response, please investigate!',
            });
          }
          resolve(response);
        },
        (error: any) => {
          if (error && error.response && error.response.status !== 412 && error.response.status <= 499) {
            reject(error);
            return;
          }
          setTimeout(() => {
            if (retriesLeft === 1) {
              if (!error || !error.response) {
                this.telemetryService.traceError(Requests.HttpResponse, {
                  url: supportServiceUrl,
                  request: supportServiceRequest,
                  message: 'Api call succeeded but no response, please investigate!',
                });
              }
              reject(error);
              return;
            }
            this.retry(supportServiceFn, supportServiceUrl, supportServiceRequest, retriesLeft - 1).then(
              resolve,
              reject
            );
          }, interval);
        }
      );
    });
  };
}
